import { cardStateName } from "./constants";

const getCardState = (store) => store[cardStateName];
export const getUserCard = (s) => getCardState(s).card;
